let accountTypeKeys = {
    Trial: 'hGjl234dhF4Gjl2kG48A0dffFS',
    Standard: 'hF4Gjl2khF4Gjl2khF4Gjl2kS'
}

export default accountTypeKeys